import { getListViewStore } from 'mini-mail-list-store/lib/store/Store';
import { mutatorAction } from 'satcheljs';

/** Mutator action to set the selectedTableViewId in listViewStore */
export const setSelectedTableViewId = mutatorAction(
    'setSelectedTableViewId',
    (tableViewId: string) => {
        getListViewStore().selectedTableViewId = tableViewId;
    }
);
